import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ExcelLocationImport.frontend.types'

@Injectable({ providedIn: 'root' })
export class ExcelLocationImport_sample_batch_crudService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<{ reasons?: string[], response?: string }> 
  {
    let url = `${environment.backendUrl}api/ExcelLocationImport/functions/sample_batch_crud`;
    
    const options = {
    }
    
    const body = null;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

